import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectRecognition = (state: AppState) => state.recognition;

export const getReceivedRecognitions = () => createSelector(selectRecognition, (state) => state.receivedRecognitions);
export const getReceivedRecognitionsTotal = () =>
  createSelector(selectRecognition, (state) => state.receivedRecognitionsTotal);
export const getReceivedRecognitionsIsLoaded = () =>
  createSelector(selectRecognition, (state) => state.receivedRecognitionsIsLoaded);
// feed-failed-page-plan.md (A/C'): the failure flag and the landed-page counter, each read
// independently of receivedRecognitionsIsLoaded/receivedRecognitions above.
export const getReceivedRecognitionsLoadFailed = () =>
  createSelector(selectRecognition, (state) => state.receivedRecognitionsLoadFailed);
export const getReceivedRecognitionsLoadedPages = () =>
  createSelector(selectRecognition, (state) => state.receivedRecognitionsLoadedPages);
export const getReceivedRecognitionsFilter = () => createSelector(selectRecognition, (state) => state.receivedFilter);

export const getSentRecognitions = () => createSelector(selectRecognition, (state) => state.sentRecognitions);
export const getSentRecognitionsTotal = () => createSelector(selectRecognition, (state) => state.sentRecognitionsTotal);
export const getSentRecognitionsIsLoaded = () =>
  createSelector(selectRecognition, (state) => state.sentRecognitionsIsLoaded);
// Sent's own independent mirror of the Received pair above.
export const getSentRecognitionsLoadFailed = () =>
  createSelector(selectRecognition, (state) => state.sentRecognitionsLoadFailed);
export const getSentRecognitionsLoadedPages = () =>
  createSelector(selectRecognition, (state) => state.sentRecognitionsLoadedPages);
export const getSentRecognitionsFilter = () => createSelector(selectRecognition, (state) => state.sentFilter);

export const getReviewRecognitions = () => createSelector(selectRecognition, (state) => state.reviewRecognitions);
export const getReviewRecognitionsTotal = () =>
  createSelector(selectRecognition, (state) => state.reviewRecognitionsTotal);
export const getReviewRecognitionsIsLoaded = () =>
  createSelector(selectRecognition, (state) => state.reviewRecognitionsIsLoaded);
export const getReviewRecognitionsFilter = () => createSelector(selectRecognition, (state) => state.reviewFilter);

export const getRecognition = () => createSelector(selectRecognition, (state) => state.recognition);
export const getCoreValues = () => createSelector(selectRecognition, (state) => state.coreValues);
// follow-up 111 / 923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md's own L5: read independently of getCoreValues
// above, mirroring every other xLoadFailed selector's convention in this file.
export const getCoreValuesLoadFailed = () => createSelector(selectRecognition, (state) => state.coreValuesLoadFailed);

export const getPendingCount = () => createSelector(selectRecognition, (state) => state.pendingCount);

export const getRecognitionCounts = () => createSelector(selectRecognition, (state) => state.recognitionCounts);
